export default __webpack_public_path__ + "static/media/1-1.1f6b8939.png";